import React, { Fragment } from "react";
import PropTypes from "prop-types";
import CustomPropTypes from "../utils/customPropTypes";
import GenericBanner from './GenericBanner/GenericBanner';
import style from '../../scss/components/HeroGrid';
export default class HeroGrid extends React.Component {
    static propTypes = {
        items: PropTypes.arrayOf(
            PropTypes.shape({
                eyebrow: PropTypes.string,
                title: PropTypes.string,
                description: PropTypes.string,
                image: CustomPropTypes.Image,
                mobileImage: CustomPropTypes.Image,
                button: CustomPropTypes.Link
            })
        )
    };
    render() {
        var urlData = window.location.href;

        return (
            <section className="hero-grid-section">
                <div className="container">
                    <ul className="hero-grid-list">
                        {this.props.items.map(function (objItem, index) {
                            return (
                                <li key={index}>
                                    <GenericBanner {...objItem} controlType={GenericBanner.ControlTypes.HeroGridCard}>
                                    </GenericBanner>
                                </li>
                            );
                        })}
                    </ul>
                </div>

                {/* {urlData.includes("products") && (
                    <div className="banner-img-content">

                        <div className="left-content">
                            <div className="left-content-data">
                                <p>We have answers to all your questions.
                                    As industry pioneers since 1952, we've learned a lot along the way. And we’re more than happy to share.</p>
                                <a href="https://www.hunterlab.com/en/contact/" className="contact-btn">Contact us</a>
                            </div>
                        </div>
                    </div>
                )
                } */}

            </section>
        );
    }
}
